module.exports = __webpack_public_path__ + "img/authorized-competitions-fr.a386bb71.png";